import SceneTemplate from '../../components/scene-template'
import { BTN_ENDGAME_CONFIG, COLORS, TOOLBOX_CONFIG, WORD_BOX_STYLE } from '../../constants/game'
import { WORD_LIST_1, WORD_LIST_2, WORD_LIST_3, BACKGROUND_CONTEXT } from './bathroom.constants'

const overrideStyle = () => {
  // OVERRIDE COLORS
  TOOLBOX_CONFIG.fillColor = COLORS.primaryBlue;// 0x04205D;
  BTN_ENDGAME_CONFIG.fillColor = COLORS.secondaryPink;
  WORD_BOX_STYLE.fontStyle.color = COLORS.HEX.accentPink;
};
export class Bathroom extends SceneTemplate {
  constructor() {
    super('bathroom', WORD_LIST_1, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Baño'
  }
}
export class Bathroomv2 extends SceneTemplate {
  constructor() {
    super('bathroomv2', WORD_LIST_2, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Baño'
  }
}

export class Bathroomv3 extends SceneTemplate {
  constructor() {
    super('bathroomv3', WORD_LIST_3, BACKGROUND_CONTEXT, overrideStyle);
    this.roomName = 'Baño'
  }
}